<template>
  <div class="container-fluid mt-4" dir="rtl">
    <div class="row">
      <!-- ستون سایدبار -->
      <div class="col-3">
        <Sidebar />
      </div>

      <!-- ستون اصلی -->
      <div
        class="col-9 d-flex align-items-center justify-content-center"
        style="min-height: calc(100vh - 100px);"
      >
        <div
          class="card card-body border-0 w-100"
          style="margin-right: -6.5vw; background-size: cover; padding-top: 11.3vw;"
        >
          <div style="width: 100%; background-color: #eceded" class="rounded p-3">

            <!-- تب‌ها -->
            <ul class="nav nav-tabs justify-content-center mb-1">
              <li class="nav-item" v-for="year in years" :key="year">
                <a
                  class="nav-link"
                  :class="{ active: activeYear === year }"
                  href="#"
                  @click.prevent="changeYear(year)"
                >
                  {{ toPersianDigits(year) }}
                </a>
              </li>
            </ul>

            <!-- ردیف سه ستونه گیج -->
            <div class="row g-3 mt-3">
              <div class="col-4" v-for="(title, i) in gaugeTitles" :key="i">
                <div
                  class="card p-2 d-flex flex-column align-items-center justify-content-center"
                  style="height: 17vw;"
                >
                  <canvas
                    :ref="el => canvasRefs[i] = el"
                    style="width: 100%; height: 100%; background: #ffffff; padding: 1vw; border-radius: 5px;"
                  ></canvas>
                  <div class="fw-bold mt-2" style="font-size: 1vw;
                    background: white;
                    width: 100%;
                    margin-top: -0.1vw !important;
                    padding-bottom: 2vw;">
                    {{ title }}
                  </div>
                </div>
              </div>
            </div>

            <!-- سلکت هدف استراتژیک -->
            <div class="mt-5 d-flex justify-content-center">
              <label class="fw-bold " style="margin-left: 0.7vw;">انتخاب هدف استراتژیک</label>
              <select v-model="selectedGoal" class="form-select w-50">
                <option disabled value="">یک هدف انتخاب کنید</option>
                <option v-for="goal in goals" :key="goal.id" :value="goal.id">
                  {{ goal.title }}
                </option>
              </select>
            </div>

            <!-- جدول وضعیت اقدامات -->
            <div v-if="selectedGoal" class="mt-4">
              <h6 style="font-size:1vw !important" class="fw-bold text-center bg-success text-white p-2 rounded">
                گزارش وضعیت هدف: {{ getGoalTitle(selectedGoal) }} (سال {{ toPersianDigits(activeYear) }})
              </h6>
              <table class="table table-bordered text-center align-middle">
                <thead class="table-primary">
                  <tr>
                    <th>هدف</th>
                    <th>واحد متولی</th>
                    <th>اقدام استراتژیک</th>
                    <th>تحقق برنامه</th>
                    <th>وضعیت برنامه</th>
                    <th>تحقق بودجه</th>
                    <th>وضعیت بودجه</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in getGoalRows(selectedGoal)" :key="index">
                    <td>{{ row.goal }}</td>
                    <td>{{ row.unit }}</td>
                    <td>{{ row.action }}</td>
                    <td>{{ toPersianDigits(row.planProgress) }}٪</td>
                    <td>{{ row.planStatus }}</td>
                    <td>{{ toPersianDigits(row.budgetProgress) }}٪</td>
                    <td>{{ row.budgetStatus }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- نمودار روند -->
            <div v-if="selectedGoal" class="mt-5 d-flex justify-content-center mb-5">
              <div style="width:400px; height:400px;">
                <canvas style="width: 400px;
    height: 400px;
    display: block;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 5px;
    padding: 1vw 3vw 1vw 1vw;" ref="trendChart" ></canvas>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar/Sidebar";
import { defineComponent, ref, onMounted, watch, nextTick } from "vue";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

export default defineComponent({
  name: "HomeView",
  components: { Sidebar },
  setup() {
    const years = [1399, 1400, 1401, 1402, 1403, 1404];
    const activeYear = ref(1404);
    const gaugeTitles = ["تحقق بودجه", "تحقق اقدامات", "تحقق اهداف"];
    const canvasRefs = ref([null, null, null]);
    let charts = [null, null, null];

    // رنگ‌های هر گیج (لایه دوم)
    const gaugeColors = ["#4caf50", "#2196f3", "#ff9800"];

    // تبدیل اعداد به فارسی
    const toPersianDigits = (num) =>
      num.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

    // دیتای گیج
    const fakeData = {
      1399: [80, 65, 70],
      1400: [55, 75, 90],
      1401: [95, 50, 60],
      1402: [40, 88, 70],
      1403: [77, 99, 85],
      1404: [60, 45, 95],
    };

    // اهداف
    const goals = [
      { id: 1, title: "افزایش بهره‌وری منابع سازمانی" },
      { id: 2, title: "کاهش هزینه‌ها و افزایش کارایی" },
      { id: 3, title: "بهبود فرآیندهای داخلی" },
      { id: 4, title: "تحول دیجیتال" },
      { id: 5, title: "ارتقاء کیفیت خدمات" },
      { id: 6, title: "افزایش درآمد" },
      { id: 7, title: "مدیریت منابع انسانی" },
      { id: 8, title: "نوآوری در محصولات" },
      { id: 9, title: "رضایت مشتریان" },
      { id: 10, title: "گسترش بازار" },
    ];

    // دیتای جدول
    const goalRows = {};
    years.forEach((year) => {
      goalRows[year] = {};
      goals.forEach((goal) => {
        goalRows[year][goal.id] = [
          {
            goal: goal.title,
            unit: `واحد ${goal.id}`,
            action: `اقدام مربوط به ${goal.title} (${year})`,
            planProgress: Math.floor(Math.random() * 100),
            planStatus: ["در حال انجام", "تکمیل‌شده", "متوقف"][Math.floor(Math.random() * 3)],
            budgetProgress: Math.floor(Math.random() * 100),
            budgetStatus: ["کافی", "نیازمند اصلاح", "کمبود بودجه", "مصوب"][Math.floor(Math.random() * 4)],
          },
        ];
      });
    });

    const selectedGoal = ref("");

    const getGoalTitle = (id) => goals.find((g) => g.id === id)?.title || "";
    const getGoalRows = (id) => goalRows[activeYear.value]?.[id] || [];

    const changeYear = (year) => {
      activeYear.value = year;
      selectedGoal.value = "";
    };

    // --- نمودار گیج ---
    const renderGauge = (index, value) => {
      if (!canvasRefs.value[index]) return;
      if (charts[index]) charts[index].destroy();

      const mainColor = gaugeColors[index];

      charts[index] = new Chart(canvasRefs.value[index], {
        type: "doughnut",
        data: {
          datasets: [
            {
              // لایه اول: تقسیم 3 رنگ
              data: [50, 25, 25],
              backgroundColor: ["#f44336", "#ff9800", "#4caf50"],
              borderWidth: 0,
              circumference: 180,
              rotation: -90,
              cutout: "80%",
            },
            {
              // لایه دوم: درصد واقعی
              data: [value, 100 - value],
              backgroundColor: [mainColor, "transparent"],
              borderWidth: 0,
              circumference: 180,
              rotation: -90,
              cutout: "80%",
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false }, tooltip: { enabled: false } },
        },
        plugins: [
          {
            id: "customText",
            afterDraw(chart) {
              const { width, height, ctx } = chart;
              ctx.save();

              // درصد وسط گیج
              ctx.font = `bold ${width / 10}px Shabnam`;
              ctx.fillStyle = mainColor;
              ctx.textAlign = "center";
              ctx.textBaseline = "middle";
              ctx.fillText(`${toPersianDigits(value)}٪`, width / 2, height / 1.15);

              // برچسب ۰٪
              ctx.font = `normal ${width / 18}px Shabnam`;
              ctx.fillStyle = "#555";
              ctx.fillText("۰٪", width * 0.1, height / 1.1);

              // برچسب ۱۰۰٪
              ctx.fillText("۱۰۰٪", width * 0.9, height / 1.1);

              ctx.restore();
            },
          },
        ],
      });
    };

    const renderAllGauges = () => {
      fakeData[activeYear.value].forEach((val, i) => renderGauge(i, val));
    };

    // --- نمودار روند ---
    const trendChart = ref(null);
    let trendChartInstance = null;

    const trendData = {};
    goals.forEach(goal => {
      trendData[goal.id] = years.map(year => ({
        year,
        value: Math.floor(Math.random() * 100)
      }));
    });

    const renderTrendChart = (goalId) => {
      if (!trendChart.value) return;
      if (trendChartInstance) trendChartInstance.destroy();

      const data = trendData[goalId] || [];

      trendChartInstance = new Chart(trendChart.value, {
        type: "line",
        data: {
          labels: data.map(d => toPersianDigits(d.year)),
          datasets: [
            {
              label: "درصد تحقق",
              data: data.map(d => d.value),
              borderColor: "#2195f3ff",
              backgroundColor: "rgba(131, 33, 243, 0.2)",
              tension: 0.3,
              fill: true,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              labels: { font: { family: "Shabnam" } }
            },
            title: {
              display: true,
              text: "روند تحقق بر حسب سال (%)",
              font: { family: "Shabnam", size: 14 }
            }
          },
          scales: {
            x: {
              ticks: {
                callback: (val, index) => toPersianDigits(data[index].year),
                font: { family: "Shabnam" }
              },
              title: {
                display: true,
                text: "سال",
                font: { family: "Shabnam" }
              }
            },
            y: {
              min: 0,
              max: 100,
              ticks: {
                stepSize: 20,
                callback: (val) => toPersianDigits(val),
                font: { family: "Shabnam" }
              },
              title: {
                display: true,
                text: "درصد تحقق",
                font: { family: "Shabnam" }
              }
            }
          }
        }
      });
    };

    // lifecycle
    onMounted(renderAllGauges);
    watch(activeYear, renderAllGauges);
    watch(selectedGoal, async (newGoal) => {
      if (newGoal) {
        await nextTick();
        renderTrendChart(newGoal);
      }
    });

    return {
      years,
      activeYear,
      gaugeTitles,
      canvasRefs,
      goals,
      selectedGoal,
      getGoalTitle,
      getGoalRows,
      changeYear,
      trendChart,
      toPersianDigits
    };
  },
});
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/rastikerdar/shabnam-font@v5.0.1/dist/font-face.css');
* {
  font-family: 'Shabnam', sans-serif !important;
}
</style>
